module.exports = __webpack_public_path__ + "static/logo-bc960d902015ead1dbfd1f0ad80b60ae.svg";